












































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {acceptDonations} from '@/ts/donations/accept-donations';
import {reformatDate} from '@/ts/helpers';

export default {
    name: 'TheTableDonations',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        date(date) {
            return reformatDate(date);
        },
        accept(id) {
            const score = '';
            this.$swal.fire({
                title: 'Оцененте дарението',
                text: 'Колко порции бяха дарени?',
                input: 'text',
                type: 'question',
                inputValue: score,
                inputValidator: (value) => {
                    return !(value >= 1 && value <= 100) && 'Въведете число от 1 до 100.';
                },
            }).then((response) => {
                if (response.value !== undefined) {
                    acceptDonations(id, response.value).then(() => {
                        this.$swal.fire(
                            'Дарението прието успешно',
                            '',
                            'success',
                        );
                    });
                }
            });
        },
    },
};
